import { render, staticRenderFns } from "./TabelaPatrimonioPf.vue?vue&type=template&id=3b807646&lang=pug"
import script from "./TabelaPatrimonioPf.vue?vue&type=script&lang=js"
export * from "./TabelaPatrimonioPf.vue?vue&type=script&lang=js"
import style0 from "./TabelaPatrimonioPf.vue?vue&type=style&index=0&id=3b807646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports